import { render, staticRenderFns } from "./Inclusions.vue?vue&type=template&id=c860675e&scoped=true"
import script from "./Inclusions.vue?vue&type=script&lang=js"
export * from "./Inclusions.vue?vue&type=script&lang=js"
import style0 from "./Inclusions.vue?vue&type=style&index=0&id=c860675e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c860675e",
  null
  
)

export default component.exports